module.exports = __webpack_public_path__ + "0185bca66534a31c0f4660edc1ae0afc.svg";